import React, { ReactElement, useEffect, useState } from "react"
import Post from "../../../interfaces/post";
import PodcastCard from "../../Cards/BlogCard/PodcastCard";
import cmsToPodcast from "../../../utils/transformers/cmsToPodcast";
import BlogCard from "../../Cards/BlogCard/BlogCard";
import cmsToBlog from "../../../utils/transformers/cmsToBlog";
import capitalize from "../../../utils/capitalize";
import Carousel from "../../Carousel/Carousel";
import { Link } from "gatsby";
import Button, { ButtonTypes } from "../../Button/Button";
import AnimatedCard from "../../Cards/AnimatedCard/AnimatedCard";

export interface PostsSlideProps {
    posts: Post[],
    className?: string,
}

const PostsSlide : React.FC<PostsSlideProps> = ({ posts, className='' }) : ReactElement => (
    <div className={`flex gap-4 ${className} py-20`}>
    {
        posts.map((post, i) => (
            <AnimatedCard key={`animated-card-${i}`} className='w-[clamp(310px,100%,420px)]'>
                {
                    post.type === 'podcast' ?
                        <PodcastCard {...cmsToPodcast(post)} /> :
                        <BlogCard {...cmsToBlog(capitalize(post.type || ''))(post)} 
                            className={post.type === 'webinar'? '[&_.post-type]:bg-rich-violet' : ''} />
                }
                </AnimatedCard>
        ))
    }
    </div>
);

export interface PostsGalleryProps extends PostsSlideProps {
    title: string,
    subtitle: string,
    linkTo: string,
}
            
const PostsGallery: React.FC<PostsGalleryProps> = ({ posts, title, subtitle, linkTo, className=''}) => {
    const postPerSlide = 3;
    
    const slides = [...Array(Math.ceil(posts.length/postPerSlide))].map((s, i) => (
        <PostsSlide key={i} posts={posts.slice(i * postPerSlide, i * postPerSlide + postPerSlide)}
            className='mx-[clamp(0rem,calc(100%-1020px),4rem)]'/>
    ));

    return (
        <div className={`flex flex-col items-center ${className}`}>
            <h2 className=" text-vibrant-green pt-5 text-center">{title}</h2>
            <p className="subtitle-2-light text-deep-blue px-10 pt-10 -mb-10 text-center">{subtitle}</p>
            <div className="hidden lg:contents">
                <Carousel
                    showSelectorButtons={false}
                    showSlideButtons={slides.length > 1 ? true : false}
                    slides={slides}
                    arrowButtonColor="fill-vibrant-green"
                    slideSelectorColor="bg-[#2ad2c94d]"
                    selectedSlideSelectorColor="bg-[#2AD2C9]"
                    customArrowSize="w-[2.75rem] h-[5.5rem]"
                    height="h-full"
                />
            </div>
            <PostsSlide posts={posts} className="flex-wrap justify-center items-center lg:hidden" />
            <div className="gallery-more w-full -mt-10 mb-10 flex flex-col md:flex-row md:items-center gap-4
                lg:px-[clamp(0rem,calc(100%-1020px),4rem)]">
                <div className="h-0 border-deep-blue opacity-25 border-[4px] rounded-[4px] mb-2 flex-grow"></div>
                <Link to={linkTo} className="w-full md:w-[clamp(280px,30%,380px)] cursor-pointer">
                    <Button title="See More" buttonType={ButtonTypes.Principal}
                        className="w-full" />
                </Link>
            </div>
        </div>
    );
}
            
export default PostsGallery;
